/**
 * Created by bszggg on 2019. 06. 15..
 */
import moment from 'moment';
import SettingsContainer from '@/helper/SettingsContainer';
import hash from "object-hash";
import Helper from "./Helper";

/**
 * Helper General functions for all of product parts
 */
const HelperRole = {


  healthCheckHandler: function (modul, res) {
    /*
     user
     companymoduleIds
     userrolesforcompanyIds
     * */
    if (res && res.data && res.result === true) {
      const state = HelperRole.makeStateFromData(res.data);
      const copiedState = Object.assign({}, modul.$store.state);
      const newState = Object.assign(copiedState, state);
      modul.$store.replaceState(newState);

//       if (res && res.data && res.data.auth_user) {
//
//         modul.$store.state.id_company = (res.data.auth_user && res.data.auth_user.id_company_actual) ? (res.data.auth_user.id_company_actual) : null;
//         const user = Object.assign({}, res.data.auth_user);
//         delete(user.id_company_actual);
//         modul.$store.state.user = user; //res.data.auth_user;
//         modul.$store.state.userhash = hash(user); // res.data.auth_user
//         modul.$store.state.user.name = res.data.auth_user.firstName + " " + res.data.auth_user.lastName;
//         // modul.$store.state.user.name = res.data.auth_user.first_name + " " + res.data.auth_user.last_name;
// //                modul.$store.state.user.usercompanies = res.data.usercompanies ;
//       }
//       if (res && res.data.companymodules) {
//         const companymoduleIds = [];
//         if (Array.isArray(res.data.companymodules)) {
//           Array.prototype.forEach.call(res.data.companymodules, function (e) {
//             companymoduleIds.push(e.id2);
//           })
//         }
//         modul.$store.state.companymoduleIds = companymoduleIds;
//         modul.$store.state.companymodules = res.data.companymodules;
//         modul.$store.state.companymoduleshash = hash(res.data.companymodules);
//       }
//       if (res && res.data.usercompanies) {
//         modul.$store.state.usercompanies = res.data.usercompanies;
//         modul.$store.state.usercompanieshash = hash(res.data.usercompanies);
//       }
//       if (res && res.data.userrolesforcompany) {
//         const userrolesforcompanyIds = [];
//         if (Array.isArray(res.data.userrolesforcompany)) {
//           Array.prototype.forEach.call(res.data.userrolesforcompany, function (e) {
//             userrolesforcompanyIds.push(e.id2);
//           })
//         }
//         modul.$store.state.userrolesforcompanyIds = userrolesforcompanyIds;
//         modul.$store.state.userrolesforcompany = res.data.userrolesforcompany;
//         modul.$store.state.userrolesforcompanyhash = hash(res.data.userrolesforcompany);
//       }
//       modul.$store.state.healthCheckHash = hash(Helper.String(modul.$store.state.id_company)+Helper.String(modul.$store.state.userhash)+Helper.String(modul.$store.state.companymoduleshash)+Helper.String(modul.$store.state.usercompanieshash)+Helper.String(modul.$store.state.userrolesforcompanyhash));
//       modul.$store.replaceState(Object.assign({}, modul.$store.state));


    } else {
      if (modul.$router.currentRoute && modul.$router.currentRoute.name !== null && modul.$router.currentRoute.name !== "login" && modul.$router.currentRoute.name !== "register" && modul.$router.currentRoute.name !== "remember" && modul.$router.currentRoute.name !== "pset") { // routename
        console.log("redirect login from HelperRole")
        console.log(modul.$router.currentRoute)
        console.log(modul.$router.currentRoute.name)
        modul.$router.push({name: "login"})
      }
    }
  },
  healthCheckClear: function (state) {
    state.userrolesforcompanyIds = [];
    state.userrolesforcompany = [];
    state.userrolesforcompanyhash = "";
    state.healthCheckHash = "";
    state.user = {};
    state.userhash = "";
    state.companymoduleIds = [];
    state.companymodules = [];
    state.companymoduleshash = "";
    state.usercompanies = [];
    state.usercompanieshash = "";
  },
  makeStateFromData: function (data) {
    const state = {};

    if (data && data.auth_user) {
      state.id_company = (data.auth_user && data.auth_user.id_company_actual) ? (data.auth_user.id_company_actual) : null;
      const user = Object.assign({}, data.auth_user);
      delete(user.id_company_actual);
      state.user = user; //data.auth_user;
      state.userhash = hash(user); // data.auth_user
      state.user.name = data.auth_user.firstName + " " + data.auth_user.lastName;
    }
    if (data.companymodules) {
      const companymoduleIds = [];
      if (Array.isArray(data.companymodules)) {
        Array.prototype.forEach.call(data.companymodules, function (e) {
          companymoduleIds.push(e.id2);
        })
      }
      state.companymoduleIds = companymoduleIds;
      state.companymodules = data.companymodules;
      state.companymoduleshash = hash(data.companymodules);
    }
    if (data.usercompanies) {
      state.usercompanies = data.usercompanies;
      state.usercompanieshash = hash(data.usercompanies);
    }
    if (data.userrolesforcompany) {
      const userrolesforcompanyIds = [];
      if (Array.isArray(data.userrolesforcompany)) {
        Array.prototype.forEach.call(data.userrolesforcompany, function (e) {
          userrolesforcompanyIds.push(e.id2);
        })
      }
      state.userrolesforcompanyIds = userrolesforcompanyIds;
      state.userrolesforcompany = data.userrolesforcompany;
      state.userrolesforcompanyhash = hash(data.userrolesforcompany);
    }
    if (data.settings) {
      state.settings = data.settings;
      state.settingshash = hash(data.settings);
    }
    if (data.usersettings) {
      state.usersettings = data.usersettings;
    }
    if (data.frontendVersion) {
      state.frontendVersion = data.frontendVersion;
    }
    state.healthCheckHash = hash(Helper.String(state.settingshash) + Helper.String(state.id_company) + Helper.String(state.userhash) + Helper.String(state.companymoduleshash) + Helper.String(state.usercompanieshash) + Helper.String(state.userrolesforcompanyhash));

    return state;
  },
  _hasMyCompany: function (state) {
    let user = state.user;
    let usercompanies = state.usercompanies;

    let isMyCompany = false;
    if (Array.isArray(usercompanies)) {
      Array.prototype.forEach.call(usercompanies, function (e) {
        if (e.company_id_owner === user.id) {
          isMyCompany = true;
        }
      })
    }
    return isMyCompany;
  },

  /**
   *
   * Általános role vizsgáló a modul features-eihez
   *
   * @param state -- state with actual datas
   * @param moduleIds -- modul ids which is content this feature
   * @param userrolesforcompanyIds
   * @param skipUserRoleCheck -- Ez ha true, akkor az admin jogokat nem nézi, és lehet vele külön csak moduljogot lekérdezni
   * @returns {boolean}

   levizsgáljuk, hogy
   van-e cég kiválasztva (state alapján)
   -IGEN:
   --ha van, annak a cégnek van-e joga a modulid-kben felsoroltakból valamelyikhez
   ---IGEN:

   ---Ha admin, akkor a saját cége e
   -----IGEN: TRUE
   -----NEM:
   ------Ha van, annak az usernek az userrole-sben felsoroltak közül egy is (company-ra vonatkoztatva), akkor ha
   -------IGEN: TRUE
   -------NEM: FALSE

   ---NEM: FALSE
   -NEM: FALSE

   Params: Aktuális adat -- Milyen modulokkal rendelkező cégnek, --  milyen userrolessal ellátott használójának van, -- Milyen userlevellel    :   joga
   */
  hasRights: function (state, moduleIds, userrolesforcompanyIds, skipUserRoleCheck) {

    let arrUserrolesforcompanyIds = Array.from(userrolesforcompanyIds);
    let stateCompanymoduleIds = state.companymoduleIds;
    let stateuserrolesforcompanyIds = state.userrolesforcompanyIds;
    let id_company = state.id_company;
    let user = state.user;
    let uerRoleCheck = (!skipUserRoleCheck);

    let ret = false;
    // van-e cég kiválasztva (state alapján)
    if (id_company) {
      // ha van, annak a cégnek van-e joga a modulid-kben felsoroltakból valamelyikhez

      let hasmoduleid = false;
      if (moduleIds === true) { // -> skip this check
        hasmoduleid = true;
      } else if (moduleIds === false) { // -> false .. deny
        hasmoduleid = false;
      } else if (Array.isArray(moduleIds)) { // do the checks and continue
        if (Array.isArray(stateCompanymoduleIds)) {
          Array.prototype.forEach.call(stateCompanymoduleIds, function (e) {
            if (moduleIds.includes(e)) {
              hasmoduleid = true;
            }
          })
        }
      }

      if (hasmoduleid) {
        //Ha admin, akkor a saját cége e
        if (uerRoleCheck && user.role === "ADMIN" && HelperRole._hasMyCompany(state)) {
          ret = true
        } else {
          // Ha van, annak az usernek az userrole-sben felsoroltak közül egy is (company-ra vonatkoztatva), akkor ha
          let hasuserrole = false;

          if (userrolesforcompanyIds === true) { // -> skip this check, true -> access
            hasuserrole = true;
          } else if (userrolesforcompanyIds === false) { // -> false .. deny
            hasuserrole = false;
          } else if (Array.isArray(stateuserrolesforcompanyIds)) {
            Array.prototype.forEach.call(stateuserrolesforcompanyIds, function (e) {
              if (arrUserrolesforcompanyIds.includes(e)) {
                hasuserrole = true;
              }
            })
          }
          if (hasuserrole) {
            ret = true
          } else {
            ret = false;
          }
        }
      } else {
        ret = false;
      }
    } else {
      ret = false;
    }
    return ret;
  },


};

export default HelperRole;
